import React from 'react'

import {
  AlignItems,
  Box,
  Color,
  Display,
  DisplayPosition,
  FontWeight,
  Space,
  Text,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'

import goldStar from '../assets/gold-star.svg'
import { CWCVideoCard } from '../../CWCVideoCard/CWCVideoCard'
import { LandingPageContentSections } from '../../../tracking'

type CWCRecipeVideoCardProps = {
  videoURL: string
  recipeName: string
  rating: string
  tile: string
  shouldPlay: boolean
}

const RatingBadge = withCitrusTheme(Box, (theme) => ({
  background: theme.color(Color.ColdGrey_800),
  backdropFilter: 'blur(3px)',
}))

export function CWCRecipeVideoCard({
  videoURL,
  recipeName,
  rating,
  tile,
  shouldPlay,
}: CWCRecipeVideoCardProps) {
  return (
    <CWCVideoCard
      videoURL={videoURL}
      background="#11161B"
      tracking={{ section: LandingPageContentSections.REVIEWS, tile }}
      mediaLabel={recipeName}
      shouldPlay={shouldPlay}
    >
      <Box position={DisplayPosition.Absolute} bottom="16px" left="16px" width="208px">
        <Box height="72px">
          <Text color={Color.White} fontWeight={FontWeight.Bold} size={4}>
            {recipeName}
          </Text>
        </Box>
        <Space size={2} />
        <RatingBadge
          role="img"
          aria-label={`${rating} out of 5 rating`}
          display={Display.InlineFlex}
          alignItems={AlignItems.Center}
          paddingH={2}
          paddingV={1}
          style={{ borderRadius: '999px' }}
        >
          <img src={goldStar} alt="" width="12" height="12" />
          <Space direction="horizontal" size={1} />
          <Text color={Color.White} fontWeight={FontWeight.Bold} size={2}>
            {rating}
          </Text>
        </RatingBadge>
      </Box>
    </CWCVideoCard>
  )
}
